import token, { tokenToVars } from '../token';
import Upload from './upload';

export { Upload };
export default tokenToVars(Upload, token);
